import React, {useEffect} from 'react';
import wrap from 'wraptile';
import {nanoid} from 'nanoid';
import MenuItem from '@material-ui/core/MenuItem';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import {HandleChangeSelectType} from '../../QCWorkflow/QCManager/QCManagerTypes';
import {CategoryItem} from '../../QCTools/QCToolsMetadata/QCToolsMetadataTypes';

export interface CategoriesContainerProps {
    setMetadataCategories: () => void;
    categoryLabel: string;
    subCategoryLabel?: string;
    onChange: HandleChangeSelectType;
    data: CategoryItem[] | null;
    isLoading: boolean;
}

export default function CategoriesContainer(props: CategoriesContainerProps) {
    const {
        setMetadataCategories,
        categoryLabel,
        onChange,
        data,
        isLoading,
    } = props;
    
    const options = getOptions(data);
    const fetchCategories = onEffect(setMetadataCategories, isLoading);
    
    useEffect(fetchCategories, []);
    
    if (isLoading) {
        return <CircularProgress />;
    }
    
    return (
        <FormControl>
            <Select
                value={categoryLabel}
                onChange={onChange}
            >
                {options}
            </Select>
        </FormControl>
    );
}

export const mapCategoriesToOptions = ({label}: CategoryItem) => {
    return (
        <MenuItem
            key={nanoid()}
            value={label}
        >
            {label}
        </MenuItem>
    );
};

export const getOptions = (categories: CategoryItem[] | null) => {
    if (!categories) {
        return null;
    }
    
    return categories.map(mapCategoriesToOptions);
};

export const onEffect = wrap((setMetadataCategories: () => void, isLoading: boolean) => {
    if (isLoading)
        setMetadataCategories();
});
